import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { audit } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
import { BusinessChannelEventBinder, PusherEvent } from '../pusher';
/** Binds a callback to the pusher event for in-app-notifications. */ export default function InAppNotificationBinder() {
    const { fetchInAppNotifications } = useStoreActions();
    const fetchInAppNotificationsAudit = useMemo(()=>audit(fetchInAppNotifications, 10000), []);
    return /*#__PURE__*/ _jsx(BusinessChannelEventBinder, {
        source: "mgmt",
        eventName: PusherEvent.MailboxUpdated,
        callback: ()=>void fetchInAppNotificationsAudit(),
        onBind: ()=>void fetchInAppNotifications()
    });
}
